module.exports = __webpack_public_path__ + "img/amex.47d92aaf.png";